import React, { useState } from "react";
import { ChevronDown } from "lucide-react";
import { FAQS } from "../data/mock";

export function FAQSection() {
  const [open, setOpen] = useState(null);

  return (
    <section className="py-20 bg-white" data-testid="faq-section">
      <div className="max-w-4xl mx-auto px-4 sm:px-6">
        <div className="text-center mb-12">
          <span className="text-[#C9A84C] text-sm font-semibold tracking-widest uppercase">FAQ</span>
          <h2 className="font-serif text-3xl sm:text-4xl font-bold text-[#1a1a1a] mt-2 mb-3">
            Frequently Asked Questions
          </h2>
          <p className="text-gray-500">Everything you need to know about interior design in Hyderabad</p>
        </div>

        <div className="space-y-3">
          {FAQS.map((faq, i) => (
            <div
              key={i}
              className={`border rounded-xl overflow-hidden transition-all ${
                open === i ? "border-[#C9A84C]" : "border-gray-200"
              }`}
              data-testid={`faq-item-${i}`}
            >
              <button
                onClick={() => setOpen(open === i ? null : i)}
                className="w-full text-left px-6 py-5 flex justify-between items-center gap-4"
              >
                <span className="font-semibold text-[#1a1a1a] text-sm sm:text-base">{faq.q}</span>
                <ChevronDown
                  size={18}
                  className={`flex-shrink-0 text-[#C9A84C] transition-transform ${open === i ? "rotate-180" : ""}`}
                />
              </button>
              {open === i && (
                <div className="px-6 pb-5">
                  <p className="text-gray-600 text-sm leading-relaxed">{faq.a}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
